import { render } from "./ProfilePayrollDetails.vue?vue&type=template&id=6bd7cf91"
import script from "./ProfilePayrollDetails.vue?vue&type=script&lang=js"
export * from "./ProfilePayrollDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__